import React, { useContext } from 'react';
import MetricPopupConstants from './constants';
import styled from 'styled-components';

import Row from '../../../../components/Common/Row';
import Button from 'kingpin/atoms/Button';
import SingleUseMetricPopupContext from '../../../../contexts/SingleUseMetricPopupContext';
import MEDIA from '../../../../media';
import { MetricPopupPortalIdsContext } from './MetricPopupPortalIdsContext';

const BottomBarDiv = styled(Row)`
  padding: ${MetricPopupConstants.PADDING};
  border-top: 1px solid var(--color-grey-8);

  @media ${MEDIA.QUERIES.SMALL_HEIGHT} {
    padding: ${MetricPopupConstants.PADDING_SMALL};
  }
`;

const BottomBar = ({ close }: { close: () => void }) => {
  const { isSingleUsePopup, cancelButtonText } = useContext(
    SingleUseMetricPopupContext,
  );
  const { primaryActionDivId } = useContext(MetricPopupPortalIdsContext);

  return (
    <BottomBarDiv spaceBetween>
      <div>
        <Button
          type="Tertiary"
          size="Small"
          onClick={close}
          label={isSingleUsePopup ? cancelButtonText : 'Cancel'}
          icon={isSingleUsePopup ? 'chevron-left' : undefined}
        />
      </div>
      <Row>
        <div id={primaryActionDivId} />
      </Row>
    </BottomBarDiv>
  );
};

export default BottomBar;
